import $axios from '../config.js'
import { url } from '../api_urls/consumerProducts.js'
import { _post } from '@/axios/request'
// import {
//   _upload
// } from '../request.js'

// 获取列表数据
export function getGoodsFormsListData (params) {
  return $axios.post(url.goodsForms, params)
}
export function getGoodsAspectsListData (params) {
  return $axios.post(url.goodsAspects, params)
}
export function getGoodsSpaListData (params) {
  return $axios.post(url.goodsSpa, params)
}
export function getGoodsPaListData (params) {
  return $axios.post(url.goodsPa, params)
}
export function getMarketCategoryListData (params) {
  return $axios.post(url.marketCategory, params)
}
export function getSubCategoryListData (params) {
  return $axios.post(url.subCategory, params)
}
export function getSearchByLetterListData (params) {
  return $axios.post(url.searchByLetter, params)
}
export function getBrandListData (params) {
  return $axios.post(url.getBrandList, params)
}
export function getTopProductDistributionList (params) {
  return $axios.post(url.getTopProductDistributionList, params)
}
export function getTopDistributionList (params) {
  return $axios.post(url.getTopDistributionList, params)
}
export function getProductListData (params) {
  return $axios.post(url.getProductList, params)
}
export function getGoodsMarketCategoryListData (params) {
  return $axios.post(url.getGoodsMarketCategory, params)
}
// export function getRelatedBasfListData (params) {
//   console.log(url.getRelatedBasfList)
//   return $axios.post(url.getRelatedBasfList, params)
// }
/** 根据产品查详细页 */
export function getGoodsDetailData (params) {
  return $axios.post(url.goodsDetail, params)
}
/** 根据产品查询相似配方 */
export function getSimilarFormulationData (params) {
  return $axios.post(url.goodsSimilarFormulation, params)
}
export function getSimilarFormulationList (params) {
  return $axios.post(url.goodsSimilarFormulationList, params)
}
/** 产品列表推荐配方 */
export function getRecommendFormulationData (params) {
  return $axios.post(url.goodsRecommendFormulation, params)
}
/**   关联BASF产品 */
export function getRelatedBasfProductData (params) {
  return $axios.post(url.goodsRelatedBasfProduct, params)
}
/**  产品详情推荐产品 */
export function getRecommendProductData (params) {
  return $axios.post(url.goodsRecommendProduct, params)
}
/**  商品详情-推荐产品 */
export function getInterestingProductData (params) {
  return $axios.post(url.goodsInterestingProduct, params)
}
/**  商品详情-评论聚合 */
export function getGoodsProductCommentData (params) {
  return $axios.post(url.goodsProductComment, params)
}
/** 商品详情-商品点击 */
export function getGoodsProductHitData (params) {
  return $axios.post(url.goodsProductHit, params)
}
/**  商品详情-点击区域 */
export function getGoodsProductHitAreaData (params) {
  return $axios.post(url.goodsProductHitArea, params)
}
/**  商品详情-评论区域 */
export function getGoodsProductCommentAreaData (params) {
  return $axios.post(url.goodsProductCommentArea, params)
}
// 获取品牌列表
export function getBrandData (params) {
  return $axios.post(url.GET_BRAND_LIST, params)
}
// 获取顶部信息
export function getUpdateItem (params) {
  return $axios.post(url.getUpdateItem, params)
}

export function getCommentKeywords (params) {
  return $axios.post(url.getCommentKeywords, params)
}

/** Formulation with similar claim  */
// export function getRelatedBasfProductData (params) {
//   console.log(url.getRelatedBasfProduct)
//   return $axios.post(url.getRelatedBasfProduct, params)
// }



// WEBPACK FOOTER //
// ./src/axios/api/consumerProducts.js